import { IconComponent } from './types';

const InputIcon: IconComponent = (props) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)" stroke="#000">
      <path d="M12.333 7A.667.667 0 1 1 11 7a.667.667 0 0 1 1.333 0ZM3 7a.667.667 0 1 1-1.334 0A.667.667 0 0 1 3 7ZM7.667 11.667a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0ZM5.155 5.008l-.114.114-.182-.188-.01.01-1.64-1.652.12-.118 1.826 1.834Zm-1.859 5.777-.118-.119L5.01 8.842l.116.116-1.83 1.827Zm7.406-7.614.117.118-1.861 1.856-.118-.118 1.862-1.856Zm-1.71 5.665 1.827 1.837-.12.118-1.826-1.836.119-.119ZM7.667 2.333a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h14v14H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default InputIcon;
